import { StorageLocationEnum } from '__generated__/types';
import { CURRENT_REGION } from 'config/regions/config';
import { Regions } from 'config/regions/types';
import { filter } from 'es-toolkit/compat';
import { StorageState, StorageType } from 'interfaces/stores/StorageStore';

export const types = [
  {
    value: StorageType.Inventory,
    label: 'Inventory',
  },
  {
    value: StorageType.Utilization,
    label: 'Utilization',
  },
  {
    value: StorageType.Canceled,
    label: 'Canceled',
  },
];

export const inventoryStates = [
  {
    value: StorageState.NotProcessed,
    label: 'Not yet processed',
    final: false,
  },
  {
    value: StorageState.InProcessing,
    label: 'In processing (on QC)',
    final: false,
  },
  {
    value: StorageState.PartiallyProcessed,
    label: 'Partially processed (manual)',
    final: false,
  },
  {
    value: StorageState.ProcessedForRepack,
    label: 'Processed for Repack (X2C)',
    final: true,
  },
  {
    value: StorageState.ProcessedForReturn,
    label: 'Processed for Return (X2P)',
    final: true,
  },
  {
    value: StorageState.ProcessedForStorage,
    label: 'Processed for Inventory / Util',
    final: true,
  },
  {
    value: StorageState.ProcessedAndSplit,
    label: 'Processed & split',
    final: true,
  },
];

export const utilizationStates = [
  {
    value: StorageState.NotProcessed,
    label: 'Not yet processed',
    final: false,
  },
  {
    value: StorageState.TestPart,
    label: 'Test Part',
    final: false,
  },
  {
    value: StorageState.ReproductionPlanned,
    label: 'Reproduction planned',
    final: false,
  },
  {
    value: StorageState.Cancellation,
    label: 'Cancellation',
    final: false,
  },
];

export const filteredUtilizationStates = (testDeal: boolean) => {
  if (testDeal) return utilizationStates;

  return filter(utilizationStates, (state) => state.value !== StorageState.TestPart);
};

export const locationLabels: Record<StorageLocationEnum, string> = {
  [StorageLocationEnum.ShippingRoom]: 'Shipping Room',
  [StorageLocationEnum.QcRoom]: 'QC Room',
  [StorageLocationEnum.StorageRoom]: 'Storage Room',
  [StorageLocationEnum.BigRoom]: 'Big Room',
  [StorageLocationEnum.Basement]: 'Basement',
  [StorageLocationEnum.Otto2Warehouse]: 'Warehouse 2 Ottobrunn',
  [StorageLocationEnum.GlonnWarehouse]: 'Glonn Warehouse',
  [StorageLocationEnum.DbSchenkerFrance]: 'DB Schenker France',
  [StorageLocationEnum.DbSchenkerWarehouse]: 'Schenker warehouse',
  [StorageLocationEnum.LintherSpedition]: 'Linther Spedition',
  [StorageLocationEnum.Trashed]: 'Trashed',
  [StorageLocationEnum.DisposeOf]: 'Dispose of',
  [StorageLocationEnum.GotWarehouseColnbrook]: 'GOT Warehouse Colnbrook',
  [StorageLocationEnum.GotWarehouseSantry]: 'GOT Warehouse Santry',
  [StorageLocationEnum.BglRack_0]: 'BGL Rack 0',
  [StorageLocationEnum.BglRack_1]: 'BGL Rack 1',
  [StorageLocationEnum.BglRack_2]: 'BGL Rack 2',
  [StorageLocationEnum.BglRack_3]: 'BGL Rack 3',
  [StorageLocationEnum.BglRack_4]: 'BGL Rack 4',
  [StorageLocationEnum.BglRack_5]: 'BGL Rack 5',
  [StorageLocationEnum.BglRack_6]: 'BGL Rack 6',
  [StorageLocationEnum.BglRack_7]: 'BGL Rack 7',
  [StorageLocationEnum.BglRack_8]: 'BGL Rack 8',
  [StorageLocationEnum.BglRack_9]: 'BGL Rack 9',
  [StorageLocationEnum.BglRack_10]: 'BGL Rack 10',
  [StorageLocationEnum.BglRack_11]: 'BGL Rack 11',
};

const toOption = (value: StorageLocationEnum) => ({
  value,
  label: locationLabels[value],
});

const inventoryLocationsByRegion: Record<Regions, StorageLocationEnum[]> = {
  [Regions.EU]: [
    StorageLocationEnum.StorageRoom,
    StorageLocationEnum.QcRoom,
    StorageLocationEnum.GlonnWarehouse,
    StorageLocationEnum.DbSchenkerWarehouse,
    StorageLocationEnum.Otto2Warehouse,
    StorageLocationEnum.BigRoom,
    StorageLocationEnum.Basement,
    StorageLocationEnum.GotWarehouseSantry,
    StorageLocationEnum.DbSchenkerFrance,
    StorageLocationEnum.LintherSpedition,
  ],
  [Regions.TR]: [StorageLocationEnum.StorageRoom, StorageLocationEnum.ShippingRoom, StorageLocationEnum.QcRoom],
  [Regions.UK]: [
    StorageLocationEnum.StorageRoom,
    StorageLocationEnum.DisposeOf,
    StorageLocationEnum.GotWarehouseColnbrook,
    StorageLocationEnum.GotWarehouseSantry,
  ],
  [Regions.SG]: [
    StorageLocationEnum.BglRack_0,
    StorageLocationEnum.BglRack_1,
    StorageLocationEnum.BglRack_2,
    StorageLocationEnum.BglRack_3,
    StorageLocationEnum.BglRack_4,
    StorageLocationEnum.BglRack_5,
    StorageLocationEnum.BglRack_6,
    StorageLocationEnum.BglRack_7,
    StorageLocationEnum.BglRack_8,
    StorageLocationEnum.BglRack_9,
    StorageLocationEnum.BglRack_10,
    StorageLocationEnum.BglRack_11,
  ],
};

const currentRegionInventoryLocations = inventoryLocationsByRegion[CURRENT_REGION];

export const locationOptions = currentRegionInventoryLocations.map(toOption);
